/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  VALUE_DRIVER,
  DOCUMENTS_NOTIFICATION,
} from "../actions/valueDriverActions";

const initialState = {
  valueDriver: "",
  documentNotification: "",
};

const valueDriverReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALUE_DRIVER: {
      const { valueDriver } = action.payload;
      return produce(state, (draft) => {
        draft.valueDriver = valueDriver;
      });
    }

    case DOCUMENTS_NOTIFICATION: {
      const { notificationMessage } = action.payload;
      return produce(state, (draft) => {
        draft.documentNotification = notificationMessage;
      });
    }

    default: {
      return state;
    }
  }
};

export default valueDriverReducer;
